import React from 'react';
import { Document } from '../../Models/Document';
import DocumentCard from './DocumentCard';

type Props = {
  Documents: Document[];
  savedDocuments: Document[];
  categoryId?: string;
};

const DocumentGrid: React.FC<Props> = ({ Documents, savedDocuments, categoryId }) => {
  const IsDocumentSaved = (Id: number): boolean => {
    return savedDocuments.some((doc) => doc.id === Id);
  };

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
        gap: '16px',
        padding: '16px',
      }}
    >
      {Documents.map((doc) => (
        <DocumentCard
          key={doc.id}
          document={doc}
          saved={IsDocumentSaved(doc.id)}
          goBackUrl={`/how-to-guides/${categoryId ?? ''}`}
        />
      ))}
    </div>
  );
};

export default DocumentGrid;
